/*
 * @Author: liyihui
 * @Date:
 * @description: 接口请求访问地址总集，请求API
 * @Last Modified by:
 * @Last Modified time:
 */

import manageAPI from './gwManage'
import mpFileAPI from './mpFileRest'
import microRefcdAPI from './microRefcd'

const API = {
	...manageAPI,
	...mpFileAPI,
	...microRefcdAPI,
};

export default API;



// WEBPACK FOOTER //
// ./src/api/index.js